import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "BazaarVoiceLazy" */ './BazaarVoice'), {
    fallback: null,
});
